import { useCallback } from 'react';
import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { PayrollGroupRequest } from '../payrollGroup.types';

const useUpdatePayrollGroupQuery = (onSuccess?: () => void) => {
  const { mutateAsync, isLoading } = useMutation(
    (group?: PayrollGroupRequest) =>
      api.patch(API_URL.PAYROLL_GROUPS_BY_ID(group?.id as string), {
        name: group?.name,
      }),
    {
      onSuccess: () => {
        if (onSuccess) onSuccess();
      },
    }
  );

  const update = useCallback(
    async (newGroup?: PayrollGroupRequest) => {
      await mutateAsync(newGroup);
    },
    [mutateAsync]
  );

  return {
    update,
    isLoading,
  };
};

export default useUpdatePayrollGroupQuery;
